module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/6dece897239fe2ad0ce9c2f87bda3ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_arrow_up.svg
// module id = 8TuU
// module chunks = 0